import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Unlock } from "lucide-react";
import api from "@/lib/api";
import { setKiosk } from "@/lib/kiosk";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Small lock button: admin enters the 4-digit PIN to leave Vendor Market display mode.
export const KioskExit = ({ compact = false }) => {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const unlock = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      await api.post("/vendor/unlock", { pin });
      setKiosk(false); setOpen(false); setPin("");
      toast.success("Vendor display unlocked");
      navigate("/admin");
    } catch (err) { toast.error(err.response?.data?.detail || "Wrong PIN"); setPin(""); }
    setBusy(false);
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="kiosk-exit-button" title="Exit vendor display (admin PIN)" className={`inline-flex items-center gap-1.5 rounded-full border border-zinc-600 bg-[#1e222d] text-zinc-200 hover:text-white hover:border-white font-semibold ${compact ? "h-9 px-3 text-xs" : "h-12 px-5 text-sm"}`}><Lock size={compact ? 13 : 15} />Exit market</button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setPin(""); }}>
        <DialogContent className="bg-[#12141a] border-zinc-800 text-white max-w-xs" data-testid="kiosk-exit-dialog">
          <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Unlock size={16} />Exit vendor display</DialogTitle></DialogHeader>
          <p className="text-xs text-zinc-400">Enter the 4-digit admin PIN to leave the market screen and return to Admin.</p>
          <form onSubmit={unlock} className="space-y-3">
            <input type="password" inputMode="numeric" pattern="[0-9]*" maxLength={4} autoFocus value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))} placeholder="••••" data-testid="kiosk-pin-input"
              className="w-full h-14 text-center text-3xl tracking-[0.6em] rounded-xl bg-[#1e222d] border border-zinc-700 text-white focus:border-[#ff6a13] focus:outline-none" />
            <Button type="submit" disabled={busy || pin.length !== 4} data-testid="kiosk-pin-submit" className="w-full rounded-full bg-[#ff6a13] hover:bg-[#ff8a3d] text-white font-semibold disabled:opacity-40">Unlock</Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
